import { useMemo } from "react";
import { Subscription } from "../types/dailyTaskDwo";

export function useCalcWeitage(subscriptions: Subscription): number {
  return useMemo(() => {
    if (!subscriptions) return 0;

    const silver =
      (subscriptions.silver_members_registered || 0) +
      (subscriptions.silver_members_registered_12 || 0);
    const gold =
      (subscriptions.gold_members_registered || 0) +
      (subscriptions.gold_members_registered_12 || 0);
    const platinum =
      (subscriptions.platinum_members_registered || 0) +
      (subscriptions.platinum_members_registered_12 || 0);
    const star =
      (subscriptions.star_members_registered || 0) +
      (subscriptions.star_members_registered_12 || 0);
    const diamond =
      (subscriptions.diamond_members_registered || 0) +
      (subscriptions.diamond_members_registered_12 || 0);

    return silver * 1 + gold * 2 + platinum * 3 + star * 4 + diamond * 5;
  }, [subscriptions]);
}
